import { Button, Card, Flex, Select, Space, Spin } from "antd"
import { enmExportStatus } from "../../models/enums/ExportStatus";
import { useMutation, useQuery } from "react-query";
import { mdlActionTemplateListRequest } from "../../models/service-models/action/ActionTemplateListRequest";
import { Fragment, useState } from "react";
import { ActionService } from "../../services/ActionService";
import { useTranslation } from "react-i18next";
import { ActionTemplateTable } from "./ActionTemplateTable";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { mdlActionCreateParamPair } from "../../models/domain/value-objects/ActionCreateParamPair";
import { ExpandableActionDetailTable } from "./ExpandableActionDetailTable";
import { mdlSpoDeleteRequest } from "../../models/service-models/action/SpoDeleteRequest";

export type ActionListTableProps = {
    exportStatus?: enmExportStatus;
    printStatus?: enmExportStatus;
    createClicked?: boolean;
    selectedSpo?: string;
    selectedSpoSetter: Function;
    createClickSetter: Function;
    createParamPairs: mdlActionCreateParamPair[];
    setOpenMailModal: Function;
    handlePrint: Function;
    handleExport: Function;
    handleMail: Function;
}

export const ActionListTable = (props: ActionListTableProps) => {
    const [templateListRequest, setTemplateListRequst] = useState<mdlActionTemplateListRequest>({ echo: 1, displayLength: 10, displayStart: 0 });
    const { t } = useTranslation();

    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getActionTemplates", templateListRequest],
        () => {
            if (templateListRequest)
                return ActionService.SimpleSpoList(templateListRequest);

        },
        {
            refetchOnWindowFocus: false,
            enabled: !!templateListRequest && !props.createClicked,
        }
    );


    const { mutateAsync: deleteSpo, isLoading: mutateLoading, data: mutateData } = useMutation(
        (request: mdlSpoDeleteRequest) => ActionService.Delete(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    refetch();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    const handleDisplaySizeChange = (size: string) => {
        setTemplateListRequst({ ...templateListRequest, ["displayLength"]: Number(size) });
    }

    const handleDelete = (id: string) => {
        deleteSpo({ spoId: id })
    }

    const handleEdit = (id: string) => {
        props.selectedSpoSetter(id);
        props.createClickSetter(true);
    }



    const handleMail = (spoId: string) => {
        props.selectedSpoSetter(spoId);
        props.setOpenMailModal(true);
    }

    const handleExpandRowRenderer = (id: string) => {
        return <ExpandableActionDetailTable id={id} />;
    }




    let pageSizes: { name: string; id: number }[] = [{ id: 10, name: "10" }, { id: 25, name: "25" }, { id: 50, name: "50" }, { id: 100, name: "100" }]



    return (
        <Fragment>
            <Spin spinning={props.exportStatus != enmExportStatus.DONE || props.printStatus != enmExportStatus.DONE}>
                <Card loading={isLoading || mutateLoading}>
                    <div className="card-inner">
                        <Flex justify="space-between">
                            <Space direction="vertical">
                                {
                                    data && data.body && data.body.data && data.body.data.length > 0
                                    &&
                                    <Space direction="horizontal">
                                        <strong>{t("action.template.note")} :</strong><span>{t("action.template.waitingTemplateAlert")}</span>

                                    </Space>
                                }
                                <Flex>
                                    <Space direction="horizontal">
                                        <label>{t("action.template.displaySize")}</label>
                                        <Select
                                            size="middle"
                                            onFocus={onFocus}
                                            value={templateListRequest && templateListRequest.displayLength ? templateListRequest.displayLength.toString() : "10"}
                                            onChange={handleDisplaySizeChange}
                                            placeholder={t("common.displaySize")}
                                            options={pageSizes?.map(h => Object.assign(h, {
                                                label: h.name,
                                                value: h.id
                                            }))}
                                        />
                                    </Space>
                                </Flex>
                            </Space>
                        </Flex>
                        <Flex vertical>
                            <ActionTemplateTable
                                onDelete={handleDelete}
                                onEdit={handleEdit}
                                onExport={props.handleExport}
                                onPrint={props.handlePrint}
                                onSendMail={(spoId: string) => props.handleMail(spoId)}
                                expandRowRenderer={handleExpandRowRenderer}
                                dataSource={data?.body?.data}
                            />
                            <Flex justify="end">
                                <Button onClick={() => setTemplateListRequst({ ...templateListRequest, ["echo"]: templateListRequest.echo! - 1, ["displayStart"]: templateListRequest.displayStart! - templateListRequest.displayLength! })} disabled={templateListRequest.echo == 1} type="link">{t("common.previous")}</Button>
                                <Button onClick={() => setTemplateListRequst({ ...templateListRequest, ["echo"]: templateListRequest.echo! + 1, ["displayStart"]: templateListRequest.displayStart! + templateListRequest.displayLength! })} disabled={data?.body?.data?.length == 0} type="link">{t("common.next")}</Button>
                            </Flex>
                        </Flex>
                    </div>
                </Card>
            </Spin>

        </Fragment>
    )
}